import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { IBenchmarkFixingLookupService } from "../IBenchmarkFixingLookupService";

@Injectable()
export class BenchmarkFixingLookupService
  extends BaseLookupService<string, CubiqTS.BenchmarkFixingImpl>
  implements IBenchmarkFixingLookupService
{
  constructor() {
    super(CubiqTS.BenchmarkFixingImpl);
  }

  getBenchmarkFixing(cd: string): CubiqTS.BenchmarkFixingImpl {
    if (cd == undefined || cd == null) return null;
    let ret = this.getItem(cd.toString());
    return ret;
  }

  getItemKey(item: CubiqTS.BenchmarkFixingImpl): string {
    if (item.benchmarkCd != undefined && item.benchmarkCd != null)
      return item.benchmarkCd.toString();
    return null;
  }
}
